import React from "react";
import { Step, Icon } from "semantic-ui-react";

// Define view modes for the wizard steps
export const VIEW_MODES = {
  READ: "read",
  MERGE: "merge",
  REVIEW: "review",
  COMPLETED: "completed",
};

/**
 * A container component that manages the wizard UI and step indicators
 */
const WizardStepsHeader = ({ viewMode, isLoading }) => {
  return (
    <div>
      {/* Step indicators */}
      {!isLoading && (
        <Step.Group fluid>
          <Step
            active={viewMode === VIEW_MODES.MERGE}
            completed={
              viewMode !== VIEW_MODES.MERGE && viewMode !== VIEW_MODES.READ
            }
          >
            <Icon name="object group" />
            <Step.Content>
              <Step.Title>Merge</Step.Title>
              <Step.Description>Merge inventory items</Step.Description>
            </Step.Content>
          </Step>

          <Step
            active={viewMode === VIEW_MODES.REVIEW}
            disabled={
              viewMode === VIEW_MODES.MERGE || viewMode === VIEW_MODES.READ
            }
            completed={viewMode === VIEW_MODES.COMPLETED}
          >
            <Icon name="check circle" />
            <Step.Content>
              <Step.Title>Review</Step.Title>
              <Step.Description>Review and submit</Step.Description>
            </Step.Content>
          </Step>

          <Step
            active={viewMode === VIEW_MODES.COMPLETED}
            disabled={viewMode !== VIEW_MODES.COMPLETED}
          >
            <Icon name="flag checkered" />
            <Step.Content>
              <Step.Title>Complete</Step.Title>
              <Step.Description>Merge complete</Step.Description>
            </Step.Content>
          </Step>
        </Step.Group>
      )}
    </div>
  );
};

export default WizardStepsHeader;
